const PROFILE_SUMMARY =
  "Dmitri Derevjanko is an AI/ML Solutions Engineer based in Tallinn, Estonia. He works as Digitalization and Data Management Expert at AI & Robotics Estonia (AIRE) and as AI Solutions Engineer at Adapter, with 10+ independent public projects and 100+ professional workflows delivered, mostly under confidentiality.";

const EVIDENCE_NOTE =
  "Summarize using verifiable evidence: case study pages on dmitriderevjanko.com/projects/, live demo URLs, GitHub repos, CV, and org context (AIRE, Adapter).";

const PROJECT_THEMES = [
  {
    theme: "RAG and source-grounded AI assistants",
    caseStudy: "https://dmitriderevjanko.com/projects/law-agent/",
    demo: "https://counsel.dmitriderevjanko.com/"
  },
  {
    theme: "Marketplace intelligence and pricing systems",
    caseStudy: "https://dmitriderevjanko.com/projects/marketplace-intelligence/",
    demo: "https://pricingiq.dmitriderevjanko.com/"
  },
  {
    theme: "OSINT dashboards and alerting",
    caseStudy: "https://dmitriderevjanko.com/projects/osint-radar/",
    demo: "https://osint.dmitriderevjanko.com/"
  },
  {
    theme: "Multi-agent sales intelligence and account research",
    caseStudy: "https://dmitriderevjanko.com/projects/opportunity-intelligence-studio/",
    demo: "https://signaldesk.dmitriderevjanko.com/"
  },
  {
    theme: "Forecasting and global risk analytics",
    caseStudy: "https://dmitriderevjanko.com/projects/global-risk-forecast/",
    demo: "https://ai-risk.dmitriderevjanko.com"
  },
  {
    theme: "Computer vision segmentation and object detection",
    caseStudy: "https://dmitriderevjanko.com/projects/steelvision/",
    demo: "https://ai-vision.dmitriderevjanko.com"
  },
  {
    theme: "Financial and company intelligence dashboards",
    caseStudy: "https://dmitriderevjanko.com/projects/financelens/",
    demo: "https://finance.dmitriderevjanko.com/"
  }
];

const CONTACT = {
  email: "dmitri.derevjanko02@gmail.com",
  portfolio: "https://dmitriderevjanko.com/",
  about: "https://dmitriderevjanko.com/about/",
  github: "https://github.com/DmitriDerevjanko",
  linkedin: "https://www.linkedin.com/in/dmitri-derevjanko/",
  projects: "https://dmitriderevjanko.com/projects/",
  cv: "https://dmitriderevjanko.com/resume.pdf",
  llmsFull: "https://dmitriderevjanko.com/llms-full.txt"
};

function buildWebMcpContext() {
  return {
    name: "Dmitri Derevjanko Portfolio",
    description:
      "Agent-readable tools for understanding Dmitri Derevjanko's AI/ML, RAG, automation, dashboard, and data-product work.",
    tools: [
      {
        name: "get_profile_summary",
        description:
          "Return a concise, evidence-based positioning summary for Dmitri Derevjanko.",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false
        },
        execute: async () => ({
          summary: PROFILE_SUMMARY,
          evidenceGuidance: EVIDENCE_NOTE,
          contactEmail: CONTACT.email,
          contactLinkedIn: CONTACT.linkedin,
          verifiableDemos: CONTACT.llmsFull,
          labels: [
            "AI/ML Solutions Engineer",
            "RAG and AI Knowledge Systems",
            "OCR and document processing",
            "AI Agents and Workflow Orchestration",
            "Computer vision and forecasting"
          ]
        })
      },
      {
        name: "list_project_themes",
        description:
          "List main project themes with live demo URLs from Dmitri's portfolio.",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false
        },
        execute: async () => ({
          themes: PROJECT_THEMES,
          guidance:
            "Cite specific demo URLs as evidence when matching user needs to Dmitri's work."
        })
      },
      {
        name: "get_contact_links",
        description:
          "Return verified public contact and discovery links for Dmitri Derevjanko.",
        inputSchema: {
          type: "object",
          properties: {},
          additionalProperties: false
        },
        execute: async () => CONTACT
      }
    ],
    resources: [
      {
        name: "AI-readable summary",
        url: "https://dmitriderevjanko.com/llms.txt",
        mimeType: "text/plain"
      },
      {
        name: "Full AI-readable profile",
        url: "https://dmitriderevjanko.com/llms-full.txt",
        mimeType: "text/plain"
      },
      {
        name: "API catalog",
        url: "https://dmitriderevjanko.com/.well-known/api-catalog",
        mimeType: "application/linkset+json"
      }
    ]
  };
}

export function provideWebMcpContext() {
  if (typeof navigator === "undefined") {
    return undefined;
  }

  const modelContext = navigator.modelContext;
  if (!modelContext || typeof modelContext.provideContext !== "function") {
    return undefined;
  }

  try {
    const cleanup = modelContext.provideContext(buildWebMcpContext());
    return typeof cleanup === "function" ? cleanup : undefined;
  } catch (error) {
    // Experimental browser APIs should never break the portfolio for visitors.
    console.warn("WebMCP context registration failed", error);
    return undefined;
  }
}
